/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_DescInputs */

const en_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Preset Manager enables users to create, edit, and delete export presets for subtitle, and video files. Customize settings for different formats and save them for future use.`)
};

const fr_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le gestionnaire de préréglages permet de créer, modifier et supprimer des préréglages d’export pour les sous-titres et la vidéo. Personnalisez les paramètres et enregistrez-les pour une utilisation ultérieure.`)
};

const de_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Voreinstellungsmanager ermöglicht es Benutzern, Exportvoreinstellungen für Untertitel- und Videodateien zu erstellen, zu bearbeiten und zu löschen. Sie können Einstellungen für verschiedene Formate anpassen und diese zur späteren Verwendung speichern.`)
};

const it_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Preset Manager consente agli utenti di creare, modificare ed eliminare preset di esportazione per sottotitoli e file video. È possibile personalizzare le impostazioni per diversi formati e salvarle per un utilizzo futuro.`)
};

const ru_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер предустановок позволяет пользователям создавать, редактировать и удалять предустановки экспорта для файлов субтитров и видеофайлов. Настраивайте параметры для различных форматов и сохраняйте их для дальнейшего использования.`)
};

const es_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Administrador de Preajustes permite crear, editar y eliminar ajustes preestablecidos de exportación para archivos de subtítulos y video. Personaliza la configuración para diferentes formatos y guárdala para usarla en el futuro.`)
};

const zh_cn2_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设管理器允许用户创建、编辑和删除字幕和视频文件的导出预设。用户可以自定义不同格式的设置并保存以供将来使用。`)
};

const ja_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットマネージャーを使用すると、字幕ファイルやビデオファイルのエクスポートプリセットを作成、編集、削除できます。様々なフォーマットに合わせて設定をカスタマイズし、保存して後で再利用できます。`)
};

const hi_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट मैनेजर उपयोगकर्ताओं को सबटाइटल और वीडियो फ़ाइलों के लिए एक्सपोर्ट प्रीसेट बनाने, संपादित करने और हटाने की सुविधा देता है। विभिन्न फॉर्मेट के लिए सेटिंग्स को कस्टमाइज़ करें और उन्हें भविष्य में उपयोग के लिए सेव करें।`)
};

const pt_pt2_preset_manager_desc = /** @type {(inputs: Preset_Manager_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Gerenciador de Predefinições permite que os usuários criem, editem e excluam predefinições de exportação para arquivos de legenda e vídeo. Personalize as configurações para diferentes formatos e salve-as para uso futuro.`)
};

/**
* | output |
* | --- |
* | "The Preset Manager enables users to create, edit, and delete export presets for subtitle, and video files. Customize settings for different formats and save ..." |
*
* @param {Preset_Manager_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_desc = /** @type {((inputs?: Preset_Manager_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_desc(inputs)
	if (locale === "de") return de_preset_manager_desc(inputs)
	if (locale === "it") return it_preset_manager_desc(inputs)
	if (locale === "ru") return ru_preset_manager_desc(inputs)
	if (locale === "es") return es_preset_manager_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_desc(inputs)
	if (locale === "ja") return ja_preset_manager_desc(inputs)
	if (locale === "hi") return hi_preset_manager_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_desc(inputs)
	return en_preset_manager_desc(inputs)
});